import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IQuote } from '@amfam/shared/models';

@Component({
  selector: 'amfam-quote-cards',
  templateUrl: './quote-cards.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class QuoteCardsComponent {
  @Input() quote: { new: IQuote; current: IQuote };
}
